
let step = 0;
const total = 4;
const next = document.getElementById('next-btn');
const prev = document.getElementById('prev-btn');
const stepsEls = document.querySelectorAll('.wizard-step');
const panelsEls = document.querySelectorAll('.wizard-panel');

function render() {
  stepsEls.forEach((el, i) => {
    el.classList.toggle('active', i === step);
    el.classList.toggle('done', i < step);
  });
  panelsEls.forEach((el, i) => el.classList.toggle('active', i === step));
  prev.disabled = step === 0;
  prev.style.opacity = step === 0 ? '.5' : '1';
  next.textContent = step === total - 1 ? 'Finish' : 'Next →';
}
next.addEventListener('click', () => { if (step < total - 1) { step++; render(); } });
prev.addEventListener('click', () => { if (step > 0) { step--; render(); } });
